import { render, staticRenderFns } from "./SalaryComplianceReportByWorker.vue?vue&type=template&id=366e8875"
import script from "./SalaryComplianceReportByWorker.vue?vue&type=script&lang=js"
export * from "./SalaryComplianceReportByWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports